/**
 * @desc 交货单装箱率
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.packingProbability.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/packingProbability`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
